import React, { Component } from 'react';
import swal from 'sweetalert2';
import { Form } from 'react-form';
import { abonnerEcourrierE4, desabonnerEcourrierToken } from '../../../App_Code/API';
import { AfficherFeedback, Texte } from '../../ChampFormulaire';

const MAX_TENTATIVES = 3;

class PageCodeSMS extends Component {
    constructor(props) {
        super(props);

        this.codeInput = React.createRef();
        this.envoyerInput = React.createRef();
    }

    componentDidMount() {
        if (
            !this.props ||
            !this.props.location ||
            !this.props.location.state ||
            !this.props.location.state.token ||
            !this.props.location.state.data
        ) {
            this.props.history.push('/');
        }
    }

    handleSubmit = (submittedValues, event, formApi) => {
        const { code } = submittedValues;
        const { codeInput, envoyerInput } = this;
        const { history, location } = this.props;
        const { token, data } = location.state;
        envoyerInput.current.disabled = true;

        const codeValide = code === data.Code;
        AfficherFeedback(codeInput, codeValide);

        if (!codeValide) {
            formApi.setValue('code', '');

            if (formApi.getFormState().submits >= MAX_TENTATIVES) {
                desabonnerEcourrierToken(token).then(() => {
                    history.push({
                        pathname: '/Ecourrier/Invalide',
                        state: { raison: "Votre numémo de téléphone n'a pas pu être validé." },
                    });
                });
            }

            envoyerInput.current.disabled = false;
            return;
        }

        abonnerEcourrierE4(token, data).then((email) => {
            if (email) {
                history.push({
                    pathname: '/Ecourrier/Valide',
                    search: `email=${email}&ok`,
                });
            } else {
                swal('Erreur', 'Une erreur est survenue durant la validation de votre numéro de téléphone.', 'error');
                envoyerInput.current.disabled = false;
            }
        });
    };

    render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <h5 className="card-title">Abonnement au service courrier électronique</h5>
                        <div className="form-group required">
                            <label htmlFor="EcourrierCode">Code de validation</label>
                            <Texte
                                id="EcourrierCode"
                                field="code"
                                placeholder="Code reçu par SMS"
                                type="text"
                                refRef={this.codeInput}
                            />
                            <div className="invalid-feedback">Veuillez renseigner le code reçu par SMS</div>
                        </div>
                        {<label>Tentatives restantes : {MAX_TENTATIVES - formApi.getFormState().submits}</label>}
                        <button type="submit" className="btn btn-block btn-lg btn-success" ref={this.envoyerInput}>
                            Valider le code
                        </button>
                    </form>
                )}
            </Form>
        );
    }
}

export default PageCodeSMS;



// WEBPACK FOOTER //
// ./src/components/Adherent/Ecourrier/PageCodeSMS.js